import React, { useEffect, useState } from 'react'
import { FaEye } from "react-icons/fa";
import { CiLink } from "react-icons/ci";
import { FaYoutube } from "react-icons/fa6";
import { IoClose } from 'react-icons/io5';
import './logins.scss'



const Logins = () => {
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [selectedCard, setSelectedCard] = useState(null);
    const [login, setLogin] = useState([])

    const getAllLogins = async () => {
        try {
            const resp = await fetch('/data/db.json')
            if (!resp.ok) {
                throw new Error('Failed to fetch data');
            }
            const data = await resp.json()
            setLogin(data.LoginData)

        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        getAllLogins()
    })

    // Function to handle video display
    const handleWatchVideo = (videoUrl) => {
        setSelectedVideo(videoUrl);
    };

    // Function to handle video display
    const handleLiveShow = (LivePrev) => {
        setSelectedCard(LivePrev);
    };

    // Function to close the video popup
    const handleClosePopup = () => {
        setSelectedVideo(null);
    };

    // Function to close the Preview popup
    const handleCardClosePopup = () => {
        setSelectedCard(null);
    };

    const handleDownloadCode = (downloadUrl) => {
        window.open(downloadUrl);
    };

    return (
        <>
            <div className="mainLoginsReactCodes">
                <div className="subLoginsReactCodes">
                    {login.map((item, index) => (
                        <div key={index} className="LoginsReactCodes">
                            <div className="listLoginsReactCodes1 listLoginsReactCodesImg">
                                <img src={item.LoginImages} alt={item.LoginTitle} />
                                <h4 onClick={() => handleDownloadCode(item.LoginDownload)}>{item.LoginTitle}</h4>
                            </div>
                            <div className="listLoginsReactCodes2">
                                {/* <p>{item.CardDesc}</p> */}
                                <div className="LoginCodeBtns">
                                    {/* <button onClick={() => handleLiveShow(item.LoginLive)} target="_blank" rel="noopener noreferrer"><FaEye className='CardIcons' /></button> */}
                                    <button onClick={() => handleDownloadCode(item.LoginDownload)} target="_blank" rel="noopener noreferrer"><CiLink className='CardIcons' /></button>
                                    <button onClick={() => handleWatchVideo(item.LoginVideoWatch)}><FaYoutube className='CardIcons' /></button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {selectedCard && (
                    <div className="CardPopup">
                        <div className="subCardPopup">
                            <span className='CardCloseButton' onClick={handleCardClosePopup}><IoClose /></span>
                            <iframe src={selectedCard}></iframe>
                        </div>
                    </div>
                )}


                {/* Popup for Video (only one at a time) */}
                {selectedVideo && (
                    <div className="popup">
                        <div className="popup-content">
                            <span className="Login-close-button" onClick={handleClosePopup}><IoClose /></span>
                            <iframe
                                src={selectedVideo}
                                title="Portfolio Video"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerPolicy="strict-origin-when-cross-origin"
                                allowFullScreen
                            ></iframe>
                        </div>
                    </div>
                )}
            </div>
        </>
    )
}

export default Logins